import React from 'react';
import { GraphMock } from './Graph';

console.log(React.version);

// eslint-disable-next-line import/no-unused-modules, import/prefer-default-export
export function ForceGraph3D() {
  return <GraphMock />;
}
